'use client'

// src/context/config/context.ts
import { createContext } from "react";
var context_default = createContext(null);

export {
  context_default
};
//# sourceMappingURL=chunk-V3JSSRKS.mjs.map